module.exports = __webpack_public_path__ + "img/pro_thirteen_4.ad7b872e.jpg";